import gql from 'graphql-tag';

export default gql`
	mutation discardResponses($uid: String!, $responseIds: [ID!]!, $discarded: Boolean!) {
		discardResponses(input: { uid: $uid, responseIds: $responseIds, discarded: $discarded })
	}
`;
